<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Gl_backbutton />
                Новая оценочная ведомость
            </div>
            <div class="content-inner">
                <!-- --- --->
                <div class="header-for-input">Наименование оценочной ведомости</div>
                <input type="text" class="content-input input_width_50" v-model="marking_list.name" />
                <!-- --- --->
                <div class="header-for-input">Корп. стандарт</div>
                <select class="content-input input_width_50" v-model="marking_list.corpstandart_id">
                    <option value="0">Не выбрано</option>
                    <option v-for="corpst in corpstandart_list" :key="corpst.id" :value="corpst.id">{{corpst.name}}</option>
                </select>
                <!-- --- --->
                <div class="btn_main_button" @click="create_marking_list">Сохранить</div>
            </div>
        </div>
    </div>
</template>

<script>
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'NewMarkinglist',
    components: {
        Success, Error
    },
    props: ['id'],
    mixins: [
        require('../../mixins/markinglist/markinglistMixins.vue'),
        require('../../mixins/corpstandart/corpstandartMixin.vue')
    ],
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            marking_list: {
                name: '',
                corpstandart_id: 0,
                company_id: this.id
            },
            corpstandart_list: {}
        }
    },
    created() {
        this.corpstandart(this.id)
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>